import { render, staticRenderFns } from "./BirthdayComponent.vue?vue&type=template&id=2c54c624&scoped=true"
import script from "./BirthdayComponent.vue?vue&type=script&lang=js"
export * from "./BirthdayComponent.vue?vue&type=script&lang=js"
import style0 from "./BirthdayComponent.vue?vue&type=style&index=0&id=2c54c624&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c54c624",
  null
  
)

export default component.exports